module.exports = __webpack_public_path__ + "db03b34d1411049e272d2a05a1b6eb8d.png";